/**
 * @generated SignedSource<<7cbbd00759055c6ce9ccd189161a3724>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopBar_team$data = {
  readonly path: string;
  readonly " $fragmentSpreads": FragmentRefs<"PortfolioBreadcrumbs_team">;
  readonly " $fragmentType": "TopBar_team";
};
export type TopBar_team$key = {
  readonly " $data"?: TopBar_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopBar_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PortfolioBreadcrumbs_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "99a3257fad4f1a966cc2383d48e8492a";

export default node;
